'use client';

import React__default from 'react';
import { useCalendar } from '../context/calendar.js';
import { RangeCalendar } from '../styles.css.js';
import { ECalendarType } from '../types.js';
import MonthPanel from './panel/monthPanel.js';
import YearPanel from './panel/yearPanel.js';

function CalendarRangePanel() {
    var _a = useCalendar(), currentDate = _a.currentDate, calendarType = _a.calendarType;
    var currentMonth = currentDate.getMonth();
    var crrentYear = currentDate.getFullYear();
    var nextMonth = currentMonth + 1;
    var nextYear = crrentYear + 1;
    var newMonth = new Date(crrentYear, nextMonth);
    var newYear = new Date(nextYear, currentMonth);
    var renderPanel = function () {
        switch (calendarType) {
            case ECalendarType.year:
                return (React__default.createElement(RangeCalendar, null,
                    React__default.createElement(YearPanel, { currentDate: currentDate }),
                    React__default.createElement(YearPanel, { currentDate: newYear })));
            default:
                return (React__default.createElement(RangeCalendar, null,
                    React__default.createElement(MonthPanel, { currentDate: currentDate }),
                    React__default.createElement(MonthPanel, { currentDate: newMonth })));
        }
    };
    return renderPanel();
}

export { CalendarRangePanel as default };
//# sourceMappingURL=rangePanel.js.map
